import { Component } from '@angular/core';

@Component({
    selector: 'app-register-finished-page',
    templateUrl: './register-finished.component.html',
    // styleUrls: ['./register-finished.component.scss'],
    standalone: false,
})
export class RegisterFinishedComponent {}
